import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatIcon } from '@angular/material/icon';
import { DialogComponent } from '@comparit/core';

@Component({
  selector: 'ui-service-error-modal',
  templateUrl: './service-error-modal.component.html',
  styleUrl: './service-error-modal.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [DialogComponent, MatIcon],
})
export class ServiceErrorModalComponent {
  protected readonly message: string | undefined = inject(MAT_DIALOG_DATA);
}
